import { useQuery } from "@tanstack/react-query";

import type { School } from "@luna-restaurant/school-api";

import { useCurrentUser } from "@/hooks/useCurrentUser";
import { useRequest } from "@/hooks/useRequest";

export const useCurrentSchool = () => {
  const { currentUser, isLoadingUser } = useCurrentUser();
  const request = useRequest();

  const { data: currentSchool, isLoading: isLoadingSchool } =
    useQuery<School | null>({
      queryKey: ["currentSchool", currentUser?.school],
      queryFn: async () => {
        const school = await request<School>(currentUser!.school!);
        return school ?? null;
      },
      enabled: !!currentUser?.school,
      staleTime: 4 * 60 * 60 * 1000, // 4 hours
    });

  return {
    currentSchool: currentSchool ?? null,
    isLoadingSchool: isLoadingUser || isLoadingSchool,
  };
};
